export const LOAD_USER_INFO = "LOAD_USER_INFO";
export const USER_LOGOUT = "USER_LOGOUT";